var render, staticRenderFns
import script from "./SideMenuItem.vue?vue&type=script&lang=js"
export * from "./SideMenuItem.vue?vue&type=script&lang=js"
import style0 from "./SideMenuItem.vue?vue&type=style&index=0&id=7699ed9f&prod&scoped=true&lang=scss"
import style1 from "./SideMenuItem.vue?vue&type=style&index=1&id=7699ed9f&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7699ed9f",
  null
  
)

export default component.exports